var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shop-readmore",class:{
    'shop-readmore--expanded': _vm.expanded,
    'shop-readmore--inactive': !_vm.active,
    'shop-readmore--initialized': _vm.initialized,
  },style:({ '--limit': _vm.limit })},[_c('div',{ref:"content",staticClass:"shop-readmore__content"},[_vm._t("default",function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.value)}})]})],2),(_vm.active)?_c('button',{staticClass:"shop-readmore__trigger",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v("\n    "+_vm._s(_vm.expanded ? _vm.labels.less : _vm.labels.more)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }